












import { Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class ListItemStatus extends Vue {
    @Prop({ type: String, default: null }) readonly icon!: string
    @Prop({ type: String, default: null }) readonly label!: string
    @Prop({ type: String, default: 'red' }) readonly color!: string

    get hasStatusIcon(): boolean {
        return this.icon !== null
    }

    get hasStatusLabel(): boolean {
        return this.label !== null
    }

    get statusStyle(): object {
        return {
            '--status-color': this.color,
        }
    }
}
